var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"main-container"},[_c('div',{staticClass:"main-container__container"},[_c('Tops',{attrs:{"custom":_vm.colorsConfig}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }